import { Injectable } from '@angular/core';
import {
  Http,
  Response,
  URLSearchParams,
  Headers,
  RequestOptionsArgs,
  RequestOptions
} from '@angular/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { apiUrl, apiUrlcommon } from '../app.config';
import { Router } from '@angular/router';
import { DataService } from './data.service';

@Injectable()
export class NewsService {
  public defaultHeaders: Headers = new Headers();
  public isReload = new BehaviorSubject<boolean>(false);

  constructor(private _http: Http, private router: Router, private _data: DataService) {}

  getNews(newpage: number) {
    return this._http
      .request('http://www.carbell.jp/api/?sp=' + newpage)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  getNewsDetail(code: string) {
    return this._http
      .request('http://www.carbell.jp/api/?cd=' + code)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  getNewsListAdmin(page: number, size: number = 10, sort: string = '') {
    let path =
      `${apiUrl}` +
      `/topics/manage/?page=${page}&size=${size}`;
    if (sort != '') {
      path += `&sort=${sort}`;
    }
    // const path = `${apiUrl}` + `/topics/manage`;
    const queryParameters = new URLSearchParams();
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams,
      search: queryParameters
    };
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else if (response.status == 401) {
          this.deleteToken();
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  getNewsListUser(page: number, size: number = 10, sort: string = '') {
    let path =
      `${apiUrl}` +
      `/topics/?page=${page}&size=${size}`;
    if (sort != '') {
      path += `&sort=${sort}`;
    }
    // const path = `${apiUrl}` + `/topics/manage`;
    const queryParameters = new URLSearchParams();
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams,
      search: queryParameters
    };
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else if (response.status == 401) {
          this.deleteToken();
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  addNews(data: any) {
    const path = `${apiUrl}` + `/topics`;
    const queryParameters = new URLSearchParams();
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    headerParams.set('Content-Type', 'application/json;charset=utf-8');
    headerParams.set('Accept', 'application/json');
    const value = JSON.stringify(data);
    const requestOptions: RequestOptionsArgs = {
      method: 'POST',
      headers: headerParams,
      body: value,
      search: queryParameters
    };
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else if (response.status == 401) {
          this.deleteToken();
        } else if (response.status == 200) {
          return [];
        } else {
          return response.json();
        }
      })
      .catch(this.handleError2);
  }

  updateNews(data: any) {
    const path = `${apiUrl}` + `/topics/${data.id}`;
    const queryParameters = new URLSearchParams();
    this.defaultHeaders.append(
      'Content-Type',
      'application/json;charset=utf-8'
    );
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const value = JSON.stringify(data);
    const requestOptions: RequestOptionsArgs = {
      method: 'PUT',
      headers: headerParams,
      body: value,
      search: queryParameters
    };
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else if (response.status == 401) {
          this.deleteToken();
        } else if (response.status == 200) {
          return [];
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  getHomeMenu() {
    let path = `${apiUrl}/user/setting/home`;
    if (this._data.kyotenCd) {
      path += `?q=kyotenCd=${this._data.kyotenCd}`;
    }
    const queryParameters = new URLSearchParams();
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams,
      search: queryParameters
    };
    return this._http
      .request(path, requestOptions)
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else if (response.status == 401) {
          this.deleteToken();
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  private handleError(error: Response | any) {
    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    if (error.status === 401) {
      this.deleteToken();
    } else {
      return Observable.throw(error.json());
    }
  }

  private handleError2(error: any) {
    return Observable.throw(error.json());
  }

  deleteToken() {
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    if (this._data.token !== null) {
      this.clearDataAndNavigateToLogin();
      return this._http
        .delete(`${apiUrl}/auth/token`, { headers: headerParams })
        .subscribe(() => {});
    }
  }

  clearDataAndNavigateToLogin() {
    this._data.clearData();
    this.router.navigate(['/login']);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/news.service.ts